import React from "react";
import { Card, ListGroup } from "react-bootstrap";

export default function LogsScreen({ logs, height="580px", from="job" }) {
  const downloadLogs = () => {
    const logsContent = logs.map(log => `${log.timestamp} - ${log.message}`).join("\n");

    const blob = new Blob([logsContent], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "server_logs.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <Card style={{ height: {height}, overflowY: "auto" }}>
        <Card.Header
          className="d-flex justify-content-between navbar-brand-bg"
          style={{
            position: "sticky",
          }}
        >
          {from === "task" ? "Task " : 
          from === "sync" ? "Sync " : "Job "}
          Logs
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-file-earmark-arrow-down-fill"
            viewBox="0 0 16 16"
            onClick={() => {
              downloadLogs();
            }}
            style={{ cursor: "pointer" }}
          >
            <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0z" />
          </svg>
        </Card.Header>
        <Card.Body>
          <ListGroup variant="flush">
            {logs.map((log, index) => (
              <ListGroup.Item key={index} className={`bg-dark ${log?.log_level==='ERROR' || log?.sync_logs && (log?.sync_logs.toLowerCase().includes('error') || log?.sync_logs.includes('failed')) ? 'text-danger' : (log?.log_level === 'WARNING' ? 'text-warning' : 'text-white')}`}>
                {log.timestamp || log.sync_date} - {log.message || log.log_message || log.sync_logs}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
    </>
  );
}
